const localStorageKeyAuth = '__humber_auth_data__';
const localStorageKeyWebVersion = '__humber_last_web_version';

export { localStorageKeyAuth, localStorageKeyWebVersion };
